import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  readonly title: string;
  readonly description?: string;
  readonly loading?: boolean;
}

export const StepperStep: React.FC<React.PropsWithChildren<Props>> = (
  props: React.PropsWithChildren<Props>,
): React.ReactElement => {
  const { title, description, children } = props;

  const tr = useTranslator();

  return (
    <Box sx={styles.container}>
      <Typography variant="h6" aria-label="title">
        {tr(title)}
      </Typography>
      <Box height={8} />
      {description && (
        <Typography variant="body2" color="secondary">
          {tr(description)}
        </Typography>
      )}
      <Box sx={styles.divider} />

      {children}
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    position: 'relative',
    borderRadius: 'inherit',
    padding: 5,
  },
  divider: {
    height: 1,
    borderColor: '#dddddd',
    borderStyle: 'solid',
    borderWidth: 0,
    borderBottomWidth: 1,
    mt: 2.5,
    mb: 5,
  },
};
